module.exports = __webpack_public_path__ + "static/media/thomas.3c0ba259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/thomas.jpg
// module id = 619
// module chunks = 0